import { NutriLogin, NutriNoAccess } from "@/components/nutri/NutriGate";
import { NutriDashboard } from "@/components/nutri/NutriDashboard";
import { useCustomer } from "@/context/CustomerContext";

export default function NutriApp() {
  const { customer } = useCustomer();
  if (customer === null) return <div data-testid="nutri-loading" className="grid min-h-screen place-items-center font-mono text-sm text-[#a3b1aa]">Caricamento…</div>;
  if (customer === false) return <NutriLogin />;
  if (!customer.has_access) return <NutriNoAccess />;
  return <NutriDashboard />;
}
